import React from 'react';
import {useState} from 'react';
import styled from "styled-components";

import {useTheme} from "../contexts/ThemeContext";


import Card from "./Card";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";



function Container(props) {
    const [currentView, setCurrentView] = useState('Daily');
    const onViewUpdate = (e) =>{
        setCurrentView(e.textContent)
    }

    const { isDarkTheme, toggleTheme } = useTheme();

    return (
        <>
            <Navbar></Navbar>
            <Wrapper>

                <Sidebar onViewUpdate={onViewUpdate}></Sidebar>
                <CardsContainer >
                    {
                        props.items.map((el)=>{
                            return  (
                                <Card
                                    key={el.title}
                                    data={el}
                                    view={currentView}>
                                </Card>)
                        })
                    }
                </CardsContainer>
            </Wrapper>
        </>
    );
}


const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: clamp(15px, 30px, 40px);
  
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  @media (min-width: 769px) and (max-width: 992px){
    grid-template-columns: repeat(2, 1.5fr);
  }
`
const Wrapper = styled.div`
  display: flex;
  gap:30px;

  @media (max-width: 768px) {
    flex-direction: column;
  } 
`

export default Container;